import { Type as GroupAccessRestrictionType, } from '@wix/ambassador-social-groups-v1-group/types';
import { Type, } from '@wix/ambassador-social-groups-v2-group/types';
var GroupAccessRestriction = /** @class */ (function () {
    function GroupAccessRestriction(accessRestriction) {
        if (accessRestriction === void 0) { accessRestriction = {}; }
        this.accessRestriction = {};
        this.eventIds = new Set();
        this.setRestriction(accessRestriction);
    }
    GroupAccessRestriction.prototype.setRestrictionByType = function (type) {
        if (type === Type.EVENTS) {
            this.setEvents([]);
        }
        else {
            this.setRestriction(type
                ? {
                    type: type,
                }
                : null);
        }
    };
    GroupAccessRestriction.prototype.setRestriction = function (accessRestriction) {
        this.accessRestriction = accessRestriction;
        if (!accessRestriction) {
            return this.removeRestriction();
        }
        if (accessRestriction === null || accessRestriction === void 0 ? void 0 : accessRestriction.events) {
            this.eventIds = new Set(accessRestriction.events.eventIds);
        }
        else {
            this.eventIds = new Set();
        }
    };
    GroupAccessRestriction.prototype.getRestriction = function () {
        return this.accessRestriction;
    };
    GroupAccessRestriction.prototype.removeRestriction = function () {
        this.accessRestriction = null;
        this.eventIds = new Set();
        return this.accessRestriction;
    };
    GroupAccessRestriction.prototype.setEvents = function (eventIds) {
        this.eventIds = new Set(eventIds);
        this.accessRestriction = {
            type: GroupAccessRestrictionType.EVENTS,
            events: { eventIds: eventIds },
        };
        return this.accessRestriction;
    };
    GroupAccessRestriction.prototype.byEvents = function () {
        var _a;
        return ((_a = this.accessRestriction) === null || _a === void 0 ? void 0 : _a.type) === Type.EVENTS;
    };
    GroupAccessRestriction.prototype.addEventId = function (eventId) {
        this.eventIds.add(eventId);
        this.setEventIds();
    };
    GroupAccessRestriction.prototype.removeEventId = function (eventId) {
        this.eventIds.delete(eventId);
        this.setEventIds();
    };
    GroupAccessRestriction.prototype.getEventIds = function () {
        return Array.from(this.eventIds);
    };
    GroupAccessRestriction.prototype.setEventIds = function () {
        this.accessRestriction.events.eventIds = this.getEventIds();
    };
    GroupAccessRestriction.prototype.setAdminApproval = function () {
        this.setRestrictionByType(Type.ADMIN_APPROVAL);
        return this.accessRestriction;
    };
    GroupAccessRestriction.prototype.byAdminApproval = function () {
        var _a;
        return ((_a = this.accessRestriction) === null || _a === void 0 ? void 0 : _a.type) === Type.ADMIN_APPROVAL;
    };
    GroupAccessRestriction.prototype.setPaidPlans = function () {
        this.setRestrictionByType(Type.PAID_PLANS);
        return this.accessRestriction;
    };
    GroupAccessRestriction.prototype.byPaidPlans = function () {
        var _a;
        return ((_a = this.accessRestriction) === null || _a === void 0 ? void 0 : _a.type) === Type.PAID_PLANS;
    };
    return GroupAccessRestriction;
}());
export { GroupAccessRestriction };
//# sourceMappingURL=GroupAccessRestriction.js.map